export default "__VITE_ASSET__BODQW6do__"